import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { DELETE_PLC_SAFETY_EVENT } from './actionTypes';
import { deletePlcSafetyEventSuccessful, deletePlcSafetyEventFailed } from './actions';
import { getPlcSafetyAPI } from '../../../api/plcSafety';

const plcSafetyAPI = getPlcSafetyAPI();

function* deleteEvent({ payload: { event } }) {
  try {
    const response = yield call(plcSafetyAPI.deleteEvent, event.token, event.id);
    if (response.message) {
      yield put(deletePlcSafetyEventSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(deletePlcSafetyEventFailed(error));
  }
}

export function* watchDeletePlcSafetyEvent() {
  yield takeEvery(DELETE_PLC_SAFETY_EVENT, deleteEvent);
}

function* deletePlcSafetyEventSaga() {
  yield all([fork(watchDeletePlcSafetyEvent)]);
}

export default deletePlcSafetyEventSaga;
